/*
 * トップページ用
 */

jQuery(document).ready(function ($) {
	console.log('is frontpage!');

	// load resize
	var resizeTimer = false;
	$(window).on('load resize', function () {
		if (resizeTimer !== false) {
			clearTimeout(resizeTimer);
		}
		resizeTimer = setTimeout(function () {
			/*
			 * グローバルナビの#はページ内リンクに変更
			 */
			$('.to-section > a').off();
			if (window.matchMedia('(max-width:768px)').matches) {
				/*
				 * スマホ版はメニューを閉じる処理を追加
				 */
				$('.to-section > a').on('click', function (e) {
					$('#sp-menu-toggle').removeClass('active');
					$('#gnav').removeClass('visible').addClass('close').delay(700).queue(function () {
						$(this).removeClass('open close').dequeue();
					});
					$('body').removeClass('fixed').css('top', '');
				});
			}
			// スクロール設定
			$('.to-section > a').on('click', function (e) {
				var href = $(this).attr('href');
				if (href.indexOf('#') >= 0) {
					var sectionid = href.substring(href.indexOf('#') + 1, href.length);
					console.log(sectionid);
					var jump = $('#' + sectionid).offset().top - 60;	// jump先は60px（ヘッダー分）上に
				} else {
					jump = 0;
				}
				$('html,body').animate({ scrollTop: jump }, 'slow', 'swing');
				return false;
			});
		}, 200);
	});
	
});